import React from "react";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { PolicyOrAccount } from "../../../interfaces/DTO/mislaka_xml_models";
import {
  formatAllocationType,
  formatBenefitType,
  formatIsBenefitApplicable,
  formatYesNo,
  formatManagementFeePathFeatures,
  formatPensionFeeExpenseType,
} from "../../../utils/enumFormatter";
import { formatCurrency, formatPercentage } from "../../../utils/namesFormater";

interface ManagementFeeDetailsTableProps {
  policy: PolicyOrAccount;
}

export const ManagementFeeDetailsTable: React.FC<
  ManagementFeeDetailsTableProps
> = ({ policy }) => {
  const { management_fee_details } = policy;

  if (!management_fee_details || management_fee_details.length === 0) {
    return;
  }

  return (
    <Box sx={{ mt: 4, dir: "rtl" }}>
      <Typography variant="h5" gutterBottom>
        פרטי דמי ניהול
      </Typography>
    {management_fee_details.some(fee => fee.uniform_management_fee === 2) && (
      <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1, mb: 2 }}>
        <PriorityHighIcon sx={{ color: "orange" }} />
        <Typography color="textPrimary">
          קיימים מסלולים עם דמי ניהול שונים
        </Typography>
      </Box>
    )}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
             
              <TableCell>סוג הוצאה</TableCell>
              <TableCell>מאפייני מסלול</TableCell>
              <TableCell>שיעור דמי ניהול</TableCell>
               <TableCell>גביה לפי הוצאות בפועל</TableCell>
              <TableCell>תאריך עדכון אחרון</TableCell>
              <TableCell>אופן הפרשה</TableCell>
              <TableCell>סכום מקסימלי</TableCell>
              <TableCell>סך דמי ניהול</TableCell>
              <TableCell>סך דמי ניהול אחרים</TableCell>
              <TableCell>האם קיימת הטבה</TableCell>
              <TableCell>סוג הטבה</TableCell>
              <TableCell>אחוז הטבה</TableCell>
              <TableCell>תאריך סיום הטבה</TableCell>
              <TableCell>קוד מסלול השקעה ייחודי</TableCell>
              <TableCell>קוד מסלול דמי ניהול</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {management_fee_details.map((fee, index) => (
              <TableRow key={index}>
               
                <TableCell>
                  {formatPensionFeeExpenseType(fee.expense_type)}
                </TableCell>
              
                <TableCell>
                  {fee.path_features
                    ? formatManagementFeePathFeatures(fee.path_features)
                    : "—"}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  {formatPercentage(fee.management_fee_rate)}
                </TableCell>
                 <TableCell>
                  {fee.fee_determined_by_actual_expenses
                    ? formatYesNo(
                        fee.fee_determined_by_actual_expenses
                      )
                    : "—"}
                </TableCell>
                <TableCell>{fee.last_rate_update_date ?? "—"}</TableCell>
                <TableCell>
                  {formatAllocationType(fee.allocation_type)}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>{!!fee.max_fee_amount ? formatCurrency(fee.max_fee_amount) : ""}</TableCell>
                <TableCell>{!!fee.total_fees_path ? formatCurrency(fee.total_fees_path) : ""}</TableCell>
                <TableCell>{!!fee.other_fees ? formatCurrency(fee.other_fees) : ""}</TableCell>
                <TableCell>
                  {formatIsBenefitApplicable(fee.is_benefit_applicable)}
                </TableCell>
                <TableCell>{formatBenefitType(fee.benefit_type)}</TableCell>
                <TableCell>
                  {formatPercentage(fee.benefit_percentage)}
                </TableCell>
                <TableCell>{fee.benefit_expiration_date ?? ""}</TableCell>
                <TableCell>{fee.unique_investment_path_code ?? ""}</TableCell>
                <TableCell>{fee.path_code ?? ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};